import { useState } from "react";
import { Mic } from "lucide-react";
import { ouvrirMicro } from "./useDockAction";
import { jouerPop } from "./sonMicro";

const ANGLES = [0, 60, 120, 180, 240, 300];

export const MicroButton = ({ size = 56, fab = false, testId = "dock-micro-button" }) => {
  const [eclat, setEclat] = useState(0);
  const appuyer = () => {
    jouerPop();
    setEclat((n) => n + 1);
    ouvrirMicro();
  };
  return (
    <span className={`relative inline-flex ${fab ? "at-fab" : ""}`} style={fab ? undefined : { width: size, height: size }}>
      {eclat > 0 && (
        <span key={eclat} className="at-bulle pointer-events-none absolute inset-0" aria-hidden="true" data-testid="dock-micro-burst">
          <span className="at-bulle-onde" />
          {ANGLES.map((a) => <span key={a} className="at-bulle-goutte" style={{ "--angle": `${a}deg` }} />)}
        </span>
      )}
      <button
        key={`b${eclat}`}
        type="button"
        aria-label="Assistant vocal"
        data-testid={testId}
        onClick={appuyer}
        className={`at-micro relative flex items-center justify-center ${eclat ? "at-micro-rebond" : ""}`}
        style={fab ? { width: "100%", height: "100%" } : { width: size, height: size }}
      >
        <Mic size={fab ? 32 : size * 0.42} strokeWidth={2.2} />
      </button>
    </span>
  );
};
